module.exports = __webpack_public_path__ + "open_banking.22d0139f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/analytics_icons/open_banking.png
// module id = 883
// module chunks = 0